/*
 * @Author: DZH Co.,Ltd.
 * @Date: 2025-04-30 15:12:39
 * @LastEditors: DZH Co.,Ltd
 * @LastEditTime: 2025-06-12 16:36:01
 * @Description:
 * Copyright (c) 2025 by DZH Co.,Ltd., All Rights Reserved.
 */
var mixins = {
  methods: {
    // yymmdd 格式
    getToday (date, flag = '') {
      const d = date ? new Date(date) : new Date()
      const year = d.getFullYear()
      const month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)
      const day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
      var newDate = year.toString() + flag + month.toString() + flag + day.toString()
      return newDate
      // return year.toString() + flag + month.toString() + flag + day.toString()
    },
    // 保留2位小数
    toFixed(val) {
      var value = ''
      if (val === '' || val === undefined) {
        value == '--'
      } else {
        value =  parseFloat(val).toFixed(2)
      }
      return value
    },

    toUrl (url) {
      if (window.parent === window) {
        window.location.href = url;
      } else {
        if (url.slice(0, 4) !== 'http' && url.slice(0, 15) !== 'dzh_browser_url') {
          url = location.origin + location.pathname + url
        }
        window.parent.postMessage({
          action: 'link',
          data: url
        }, '*')
      }
    }
  }
}

export default mixins